<template>
    <div>
        <DataTable :value="forbiddenNames" lazy paginator dataKey="id"
            v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset" removableSort
            :totalRecords="totalRecords" :loading="loading" @page="onPage"
            @sort="onPage" :rowsPerPageOptions="[5,10,20,50]"
            selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
            filterDisplay="row" v-model:filters="searchCriteria" @update:filters="search" scrollable
            scrollHeight="calc(100vh - 300px)">
            <Column field="name" :header="$t('message.forbiddenName.name')" :sortable="true"
                filterField="name" :showFilterMenu="false"
                :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.name }}
                </template>
                <template #filter>
                    <CustomInputText name="name" v-model="searchCriteria.name" class="mb-0"
                        @update:modelValue="search"/>
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { searchForbiddenName, searchForbiddenNameCount } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneYesNo from "@/components/form/CustomSelectOneYesNo.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";

export default {
    name: "ForbiddenNameTable",
    components: {
        CustomInputText,
        Button,
        Column,
        DataTable,
        CustomSelectOneYesNo,
    },

    props: {
        modelValue: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            forbiddenNames: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.updateTotalRecords();
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
            this.updateTotalRecords();
        },

        onPage(name) {
            this.loading = true;
            this.searchCriteria.page.offset = name.first;
            this.searchCriteria.page.limit = name.rows;
            this.searchCriteria.page.sortField = name.sortField;
            this.searchCriteria.page.sortOrder = name.sortOrder;

            searchForbiddenName({ body: this.searchCriteria }).then((response) => {
                this.forbiddenNames = response.data;
                this.loading = false;
            });
        },

        updateTotalRecords() {
            searchForbiddenNameCount({ body: this.searchCriteria }).then((response) => {
                this.totalRecords = response.data;
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(name) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedName = name.data;
        },

        getClearSearchCriteria() {
            return {
                name: "",
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewName() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },
    },

    computed: {
        selectedName: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
